import React, { Component } from 'react';
import {
  Divider,
  Switch,
  Slider,
  Button,
  NumericInput,
  FormGroup,
} from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class GlobalChat extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      MinLevel: 1,
      Delay: 0,
      BrowseLinks: true,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Global Chat
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '150px' }}>Require Level</td>
              <td style={{ width: '360px' }}>
                <Slider
                  min={0}
                  max={120}
                  labelStepSize={10}
                  onChange={this.handleChange('MinLevel')}
                  value={this.state.MinLevel}
                />
              </td>
            </tr>

            <tr>
              <td>Delay</td>
              <td>
                <FormGroup
                  helperText="1000 = 1 seconds, 0 for no waiting per message"
                  className="mb-0"
                >
                  <NumericInput
                    style={{ width: '160px' }}
                    value={this.state.Delay}
                    placeholder="Type milliseconds..."
                    onValueChange={this.handleChange('Delay')}
                    min={0}
                  />
                </FormGroup>
              </td>
            </tr>

            <tr>
              <td>Browse Links</td>
              <td>
                <Switch
                  checked={this.state.BrowseLinks}
                  {...SwitchOnOff}
                  onChange={this.handleChange('BrowseLinks')}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
